"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgNarrowLane(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 -4 14 24" }, props),
        React.createElement("path", { d: "M14 0v4.781l5 4.445V16h-3v-5.67l-5-4.445V0zM8 0v16H5V0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('NarrowLane')(SvgNarrowLane);
//# sourceMappingURL=NarrowLane.js.map